<!--<div>
  <label>
            <input type="text" [(ngModel)]="search" (keypress)="enterKeySearch($event)" />
            <input type="button" value="Search" (click)="doSearch()" />
            <input type="button" value="Reset" (click)="resetSearch()" />
        </label>
</div>-->
<ul class="list-group">
  <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-action"
    *ngFor="let assessment of assessments" (click)="pickAssessment(assessment)">
    <span> <a class="badge badge-pill badge-primary mr-2" [routerLink]="['/admin','assessment','manage',assessment.uid,'view','details']"><i class='fa fa-info'></i></a>{{assessment.name}}</span>
    <span *ngIf="!hasLoaded" class="badge badge-primary badge-pill">Loading...</span>
    <span *ngIf="hasLoaded && tokensEnabled && !shouldBuyTokens(assessment)" class="badge badge-primary badge-pill" alt="Tokens Remaining" title="Tokens Remaining">{{getRemainingTokens(assessment)}}</span>
    <dac-buy-item-button *ngIf="hasLoaded && tokensEnabled && shouldBuyTokens(assessment)" [item]="assessment" (click)="triggerBuy($event)" ></dac-buy-item-button>
    <span *ngIf="!tokensEnabled" class="badge badge-primary badge-pill btn btn-sm btn-primary" alt="Pick Assessment"
      title="Assign Assessment">Add
    </span>
  </li>
</ul>


// WEBPACK FOOTER //
// ./src/app/shared/assessment-picker/assessment-picker.component.html